import { Container } from 'hypo-container';
import { DataMapper, HttpTransport } from '../api/transport';
import { RouterStore } from '@estee/elc-router';
import Api from '../api';
import DataMappings from '../api/DataMappings';
import AppViewController from '../controllers/AppViewController';
import ScreenLayoutViewController from '../controllers/ScreenLayoutViewController';
import OrderSummaryViewController from '../controllers/OrderSummaryViewController';
import User from '../domain/entities/User/User';
import TransactionRepository from '../repositories/TransactionRepository/TransactionRepository';
import AnalyticsRepository from '../repositories/AnalyticsRepository';
import UserPreferences from '../domain/entities/UserPreferences/UserPreferences';
import ShippingViewController from '../controllers/ShippingViewController';
import PaymentScreenViewController from '../controllers/PaymentScreenViewController';
import { ROUTES, NOT_FOUND } from '../routes';
import BillingViewController from '../controllers/BillingViewController';
import NotificationsViewController from '../controllers/NotificationsViewController';
import DeliveryScreenViewController from '../controllers/DeliveryScreenViewController';
import SalonCommissionViewController from '../controllers/SalonCommissionViewController';
import BopisViewController from '../controllers/BopisViewController';
import ShippingRepository from '../repositories/ShippingRepository';
import BillingRepository from '../repositories/BillingRepository';
import PackstationRepository from '../repositories/PackstationRepository';
import UserPreferencesRepository from '../repositories/UserPreferencesRepository';
import SalonRepository from '../repositories/SalonRepository';
import UIState from '../stores/UIState';
import ShippingUIState from '../stores/UIState/ShippingUIState';
import GiftCardViewState from '../stores/UIState/GiftCardUIState';
import ConfigRepository from '../repositories/ConfigRepository';
import PaymentService from '../application/services/PaymentService';
import LoadStoresService from '../application/services/LoadStoresService';
import SessionRepository from '../repositories/SessionRepository';
import AddressRepository from '../repositories/AddressRepository';
import Config from '../domain/entities/Config';
import Session from '../domain/entities/Session/Session';
import BopisStoresRepository from '../repositories/BopisStoresRepository';
import ClickAndCollectRepository from '../repositories/ClickAndCollectRepository';
import CourierStoresRepository from '../repositories/CourierStoresRepository';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';
import PackstationViewController from '../controllers/PackstationViewController';
import CreditCardsViewController from '../controllers/CreditCardsViewController';
import CreditCardFormViewController from '../controllers/CreditCardFormViewController';
import CashFormViewController from '../controllers/CashFormViewController';
import { NotificationsService } from '../application/services/NotificationsService';
import CreditCardFormStore from '../domain/entities/CreditCardFormStore/CreditCardFormStore';
import CashFormStore from '../domain/entities/CashFormStore/CashFormStore';
import TncViewController from '../controllers/TncViewController';
import TncRepository from '../repositories/TncRepository';
import KlarnaMessagingViewController from '../controllers/KlarnaMessagingViewController';
import KlarnaRepository from '../repositories/KlarnaRepository';
import CompanyBillingViewController from '../controllers/CompanyBillingViewController';
import CompanyBillingDetailsRepository from '../repositories/CompanyBillingDetailsRepository';
import MessagesRepository from '../repositories/NotificationsRepository';
import AddressTreeNodesRepository from '../repositories/AddressTreeNodesRepository';
import ConvenienceStoreViewController from '../controllers/ConvenienceStoreViewController/ConvenienceStoreViewController';
import GoogleMapsApi from '../api/GoogleMapsApi';
import { PaymentMethodViewRegistry } from '../application/payment-setup/PaymentMethodViewRegistry';
import { PaymentMethodViewController } from '../controllers/PaymentScreenViewController/PaymentMethodViewController';
import { PaymentRepository } from '../repositories/PaymentRepository/PaymentRepository';
import SalonApi from '../api/SalonApi';
import PaymentAcceptTermsAndPrivacyController from '../payment-strategies/common/controllers/PaymentAcceptTermsAndPrivacyViewController';
import ShippingOptionsViewController from '../controllers/ShippingOptionsViewController';
import AUPostCollectionsViewController from '../controllers/AUPostCollectionsViewController';
import AUPostCollectionsRepository from '../repositories/AUPostCollectionsStoreRepository';
import MelissaApi from '../api/MelissaApi';
import OptimizelyService from '../application/services/OptimizelyService';
import AddressItemViewController from '../controllers/AddressViewController/AddressItemViewController';
import Routes from '../application/routes/Routes';
import GiftWrapRepository from '../repositories/GiftWrapRepository';
import GiftWrapViewController from '../controllers/GiftWrapViewController';
import GiftWrapApi from '../api/GiftWrapApi';
import TranslationRepository from '../repositories/TranslationRepository';
import AddressFormStore from '../domain/entities/AddressFormStore';
import CharityDonationRepository from '../repositories/CharityDonationRepository';
import CharityDonationViewController from '../controllers/CharityDonationViewController';
import CharityDonationApi from '../api/CharityDonationApi';
import GiftCardViewController from '../controllers/GiftCardViewController';
import ShoppingBagViewController from '../controllers/ShoppingBagViewController';
import SalonFormStore from '../domain/entities/SalonFormStore/SalonFormStore';
import UpsAddressValidationViewController from '../controllers/UpsAddressValidationViewController';

export const diContainer = new Container();
export const serviceNames = {
  addressFormStore: 'ADRRESS_FORM_STORE',
  addressItemViewController: 'ADDRESS_ITEM_VIEW_CONTROLLER',
  addressRepository: 'ADDRESS_REPOSITORY',
  addressTreeNodesRepository: 'ADDRESS_TREE_NODE_REPOSITORY',
  analyticsRepository: 'ANALYTICS_REPOSITORY',
  apiDataMapper: 'API_DATA_MAPPER',
  apiSdk: 'API_SDK',
  appViewController: 'APP_VIEW_CONTROLLER',
  auPostCollectionsStoreRepository: 'AU_POST_COLLECTIONS_STORE_REPOSITORY',
  auPostCollectionsViewController: 'AU_POST_COLLECTIONS_VIEW_CONTROLLER',
  billingRepository: 'BILLING_REPOSITORY',
  billingViewController: 'BILLING_SCREEN_VIEW_CONTROLLER',
  bopisStoresRepository: 'BOPIS_STORES_REPOSITORY',
  bopisViewController: 'BOPIS_VIEW_CONTROLLER',
  cashFormStore: 'CASH_FORM_STORE',
  cashFormViewController: 'CASH_FORM_VIEW_CONTROLLER',
  charityDonationApi: 'CHARITY_DONATION_API',
  charityDonationRepository: 'CHARITY_DONATION_REPOSITORY',
  charityDonationViewController: 'CHARITY_DONATION_VIEW_CONTROLLER',
  clickAndCollectRepository: 'CLICK_AND_COLLECT_REPOSITORY',
  companyBillingDetailsRepository: 'COMPANY_BILLING_DETAILS_REPOSITORY',
  companyBillingViewController: 'COMPANY_BILLING_VIEW_CONTROLLER',
  config: 'CONFIG',
  configRepository: 'CONFIG_REPOSITORY',
  convenienceStoreViewController: 'CONVENIENCE_STORE_VIEW_CONTROLLER',
  courierStoresRepository: 'COURIER_STORES_REPOSITORY',
  creditCardFormStore: 'CREDIT_CARD_FORM_STORE',
  creditCardFormViewController: 'CREDIT_CARD_FORM_VIEW_CONTROLLER',
  creditCardsViewController: 'CREDIT_CARDS_VIEW_CONTROLLER',
  deliveryScreenViewController: 'DELIVERY_SCREEN_CONTROLLER',
  errorScreenViewController: 'ERROR_SCREEN_VIEW_CONTROLLER',
  giftCardUIState: 'GIFT_CARD_UI_STATE',
  giftCardViewController: 'GIFT_CARD_VIEW_CONTOLLER',
  giftWrapApi: 'GIFT_WRAP_API',
  giftWrapController: 'GIFT_WRAP_CONTROLLER',
  giftWrapRepository: 'GIFT_WRAP_REPOSITORY',
  googleMapsApi: 'GOOGLE_MAPS_API',
  httpTransport: 'HTTP_TRANSPORT',
  klarnaMessagingViewController: 'KLARNA_MESSAGE_VIEW_CONTROLLER',
  klarnaRepository: 'KLARNA_REPOSITORY',
  loadStoresService: 'LOAD_STORES_SERVICE',
  melissaApi: 'MELISSA_API',
  melissaRepository: 'MELISSA_REPOSITORY',
  notificationAfterpayService: 'NOTIFICATION_AFTERPAY_SERVICE',
  notificationsCollection: 'NOTIFICATIONS_COLLECTION',
  notificationsRepository: 'NOTIFICATIONS_REPOSITORY',
  notificationsService: 'NOTIFICATIONS_SERVICE',
  notificationsViewController: 'NOTIFICATIONS_VIEW_CONTROLLER',
  optimizelyService: 'OPTIMIZELY_SERVICE',
  orderSummaryViewController: 'ORDER_SUMMARY_VIEW_CONTROLLER',
  packstationRepository: 'PACKSTATION_REPOSITORY',
  packstationViewController: 'PACKSTATION_VIEW_CONTROLLER',
  paymentAcceptTermsAndPrivacyViewConroller: 'PAYMENT_ACCEPT_TERMS_AND_PRIVACY_VIEW_CONTROLLER',
  paymentDisableMessageRegistry: 'PAYMENT_DISABLE_MESSAGE_REGISTRY',
  paymentMethodViewController: 'PAYMENT_METHOD_VIEW_CONTROLLER',
  paymentMethodViewIconRegistry: 'PAYMENT_METHOD_VIEW_ICON_REGISTRY',
  paymentMethodViewRegistry: 'PAYMENT_METHOD_VIEW_REGISTRY',
  paymentMethodViewTitleRegistry: 'PAYMENT_METHOD_VIEW_TITLE_REGISTRY',
  paymentRepository: 'PAYMENT_REPOSITORY',
  paymentScreenViewController: 'PAYMENT_SCREEN_VIEW_CONTROLLER',
  paymentService: 'PAYMENT_SERVICE',
  routes: 'ROUTES',
  salonApi: 'SALON_API',
  salonCommissionViewController: 'SALON_COMMISSION_VIEW_CONTROLLER',
  salonFormStore: 'SALON_FORM_STORE',
  salonRepository: 'SALON_REPOSITORY',
  screenLayoutViewController: 'SCREEN_LAYOUT_VIEW_CONTROLLER',
  session: 'SESSION',
  sessionRepository: 'SESSION_REPOSITORY',
  shippingOptionsViewController: 'SHIPPING_OPTIONS_VIEW_CONTROLLER',
  shippingRepository: 'SHIPPING_REPOSITORY',
  shippingUIState: 'SHIPPING_UI_STATE',
  shippingViewController: 'SHIPPING_SCREEN_VIEW_CONTROLLER',
  shoppingBagViewController: 'SHOPPING_BAG_VIEW_CONTROLLER',
  stateRouter: 'STATE_ROUTER',
  tncRepository: 'TNC_REPOSITORY,',
  tncViewController: 'TNC_VIEW_CONTROLLER',
  transactionRepository: 'TRANSACTION_REPOSITORY',
  translationRepository: 'TRANSLATION_REPOSITORY',
  uiState: 'UI_STATE',
  upsAddressValidationViewController: 'UPS_ADDRESS_VALIDATION_VIEW_CONTROLLER',
  user: 'USER',
  userPreferences: 'USER_PREFERENCE',
  userPreferencesRepository: 'USER_PREFERENCES_REPOSITORY',
};

diContainer
  .register(serviceNames.apiDataMapper, () => new DataMapper(DataMappings))
  .register(serviceNames.httpTransport, () => new HttpTransport())
  .register(serviceNames.notificationsCollection, () => new NotificationsCollection())
  .register(serviceNames.optimizelyService, c => new OptimizelyService({
    config: c.get(serviceNames.config),
  }))
  .register(serviceNames.apiSdk, c => new Api({
    dataMapper: c.get(serviceNames.apiDataMapper),
    httpTransport: c.get(serviceNames.httpTransport),
    routes: c.get(serviceNames.routes),
    session: c.get(serviceNames.session),
  }))
  .register(serviceNames.routes, c => new Routes({
    config: c.get(serviceNames.config),
  }))
  .register(serviceNames.googleMapsApi, c => new GoogleMapsApi({
    config: c.get(serviceNames.config),
    dataMapper: c.get(serviceNames.apiDataMapper),
  }))
  .register(serviceNames.salonApi, c => new SalonApi({
    api: c.get(serviceNames.apiSdk),
  }))
  .register(serviceNames.giftWrapApi, c => new GiftWrapApi({
    api: c.get(serviceNames.apiSdk),
  }))
  .register(serviceNames.melissaApi, c => new MelissaApi({
    api: c.get(serviceNames.apiSdk),
  }))
  .register(serviceNames.stateRouter, () => new RouterStore(ROUTES, NOT_FOUND.ROUTE))
  .register(serviceNames.addressTreeNodesRepository, () => new AddressTreeNodesRepository())
  .register(serviceNames.appViewController, c => new AppViewController({
    billingRepository: c.get(serviceNames.billingRepository),
    configRepository: c.get(serviceNames.configRepository),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
    notificationsService: c.get(serviceNames.notificationsService),
    routes: c.get(serviceNames.routes),
    session: c.get(serviceNames.session),
    shippingRepository: c.get(serviceNames.shippingRepository),
    stateRouter: c.get(serviceNames.stateRouter),
    transactionRepository: c.get(serviceNames.transactionRepository),
    translationRepository: c.get(serviceNames.translationRepository),
  }))
  .register(serviceNames.screenLayoutViewController, c => new ScreenLayoutViewController({
    analyticsRepository: c.get(serviceNames.analyticsRepository),
    configRepository: c.get(serviceNames.configRepository),
    routes: c.get(serviceNames.routes),
    stateRouter: c.get(serviceNames.stateRouter),
    transactionRepository: c.get(serviceNames.transactionRepository),
    uiState: c.get(serviceNames.uiState),
  }))
  .register(serviceNames.deliveryScreenViewController, c => new DeliveryScreenViewController({
    analyticsRepository: c.get(serviceNames.analyticsRepository),
    auPostCollectionsStoreRepository: c.get(serviceNames.auPostCollectionsStoreRepository),
    bopisStoresRepository: c.get(serviceNames.bopisStoresRepository),
    configRepository: c.get(serviceNames.configRepository),
    courierStoresRepository: c.get(serviceNames.courierStoresRepository),
    giftWrapRepository: c.get(serviceNames.giftWrapRepository),
    loadStoresService: c.get(serviceNames.loadStoresService),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
    routes: c.get(serviceNames.routes),
    shippingRepository: c.get(serviceNames.shippingRepository),
    shippingUIState: c.get(serviceNames.shippingUIState),
    stateRouter: c.get(serviceNames.stateRouter),
    transactionRepository: c.get(serviceNames.transactionRepository),
    uiState: c.get(serviceNames.uiState),
    userPreferencesRepository: c.get(serviceNames.userPreferencesRepository),
  }))
  .register(
    serviceNames.paymentScreenViewController,
    diContainer.factory(
      c => new PaymentScreenViewController({
        analyticsRepository: c.get(serviceNames.analyticsRepository),
        bopisStoresRepository: c.get(serviceNames.bopisStoresRepository),
        configRepository: c.get(serviceNames.configRepository),
        giftCardUIState: c.get(serviceNames.giftCardUIState),
        notificationsCollection: c.get(serviceNames.notificationsCollection),
        paymentRepository: c.get(serviceNames.paymentRepository),
        paymentService: c.get(serviceNames.paymentService),
        shippingRepository: c.get(serviceNames.shippingRepository),
        stateRouter: c.get(serviceNames.stateRouter),
        transactionRepository: c.get(serviceNames.transactionRepository),
        uiState: c.get(serviceNames.uiState),
        userPreferences: c.get(serviceNames.userPreferences),
      }),
    ),
  )
  .register(serviceNames.giftWrapController, diContainer.factory(
    c => new GiftWrapViewController({
      configRepository: c.get(serviceNames.configRepository),
      giftWrapRepository: c.get(serviceNames.giftWrapRepository),
      notificationsCollection: c.get(serviceNames.notificationsCollection),
      sessionRepository: c.get(serviceNames.sessionRepository),
      transactionRepository: c.get(serviceNames.transactionRepository),
    }),
  ))
  .register(
    serviceNames.orderSummaryViewController,
    diContainer.factory(
      c => new OrderSummaryViewController({
        analyticsRepository: c.get(serviceNames.analyticsRepository),
        billingAddressRepository: c.get(serviceNames.billingRepository),
        bopisStoresRepository: c.get(serviceNames.bopisStoresRepository),
        configRepository: c.get(serviceNames.configRepository),
        routes: c.get(serviceNames.routes),
        shippingAddressRepository: c.get(serviceNames.shippingRepository),
        stateRouter: c.get(serviceNames.stateRouter),
        transactionRepository: c.get(serviceNames.transactionRepository),
        translationRepository: c.get(serviceNames.translationRepository),
      }),
    ),
  )
  .register(
    serviceNames.shoppingBagViewController,
    diContainer.factory(
      c => new ShoppingBagViewController({
        configRepository: c.get(serviceNames.configRepository),
        routes: c.get(serviceNames.routes),
        stateRouter: c.get(serviceNames.stateRouter),
        transactionRepository: c.get(serviceNames.transactionRepository),
        uiState: c.get(serviceNames.uiState),
      }),
    ),
  )
  .register(
    serviceNames.shippingOptionsViewController,
    diContainer.factory(
      c => new ShippingOptionsViewController({
        configRepository: c.get(serviceNames.configRepository),
        shippingAddressRepository: c.get(serviceNames.shippingRepository),
        shippingUIState: c.get(serviceNames.shippingUIState),
        transactionRepository: c.get(serviceNames.transactionRepository),
      }),
    ),
  )
  .register(
    serviceNames.shippingViewController,
    diContainer.factory(
      c => new ShippingViewController({
        addressRepository: c.get(serviceNames.shippingRepository),
        addressTreeNodesRepository: c.get(serviceNames.addressTreeNodesRepository),
        analyticsRepository: c.get(serviceNames.analyticsRepository),
        configRepository: c.get(serviceNames.configRepository),
        dataMapper: c.get(serviceNames.apiDataMapper),
        loadStoresService: c.get(serviceNames.loadStoresService),
        notificationsCollection: c.get(serviceNames.notificationsCollection),
        notificationsService: c.get(serviceNames.notificationsService),
        salonRepository: c.get(serviceNames.salonRepository),
        sessionRepository: c.get(serviceNames.sessionRepository),
        shippingUIState: c.get(serviceNames.shippingUIState),
        stateRouter: c.get(serviceNames.stateRouter),
        transactionRepository: c.get(serviceNames.transactionRepository),
      }),
    ),
  )
  .register(
    serviceNames.packstationViewController,
    diContainer.factory(
      c => new PackstationViewController({
        addressRepository: c.get(serviceNames.packstationRepository),
        addressTreeNodesRepository: c.get(serviceNames.addressTreeNodesRepository),
        configRepository: c.get(serviceNames.configRepository),
        dataMapper: c.get(serviceNames.apiDataMapper),
        notificationsCollection: c.get(serviceNames.notificationsCollection),
        notificationsService: c.get(serviceNames.notificationsService),
        transactionRepository: c.get(serviceNames.transactionRepository),
      }),
    ),
  )
  .register(
    serviceNames.salonCommissionViewController,
    diContainer.factory(
      c => new SalonCommissionViewController({
        analyticsRepository: c.get(serviceNames.analyticsRepository),
        configRepository: c.get(serviceNames.configRepository),
        salonRepository: c.get(serviceNames.salonRepository),
      }),
    ),
  )
  .register(
    serviceNames.billingViewController,
    diContainer.factory(
      c => new BillingViewController({
        addressRepository: c.get(serviceNames.billingRepository),
        addressTreeNodesRepository: c.get(serviceNames.addressTreeNodesRepository),
        configRepository: c.get(serviceNames.configRepository),
        dataMapper: c.get(serviceNames.apiDataMapper),
        notificationsCollection: c.get(serviceNames.notificationsCollection),
        notificationsService: c.get(serviceNames.notificationsService),
        transactionRepository: c.get(serviceNames.transactionRepository),
      }),
    ),
  )
  .register(
    serviceNames.bopisViewController,
    diContainer.factory(c => new BopisViewController({
      analyticsRepository: c.get(serviceNames.analyticsRepository),
      bopisStoresRepository: c.get(serviceNames.bopisStoresRepository),
      configRepository: c.get(serviceNames.configRepository),
      loadStoresService: c.get(serviceNames.loadStoresService),
      notificationsCollection: c.get(serviceNames.notificationsCollection),
      sessionRepository: c.get(serviceNames.sessionRepository),
      stateRouter: c.get(serviceNames.stateRouter),
      transactionRepository: c.get(serviceNames.transactionRepository),
    })),
  )
  .register(
    serviceNames.addressItemViewController,
    diContainer.factory(() => new AddressItemViewController()),
  )
  .register(
    serviceNames.notificationsViewController,
    diContainer.factory(
      c => new NotificationsViewController({
        notificationsService: c.get(serviceNames.notificationsService),
      }),
    ),
  )
  .register(
    serviceNames.creditCardsViewController,
    diContainer.factory(
      c => new CreditCardsViewController({
        configRepository: c.get(serviceNames.configRepository),
        transactionRepository: c.get(serviceNames.transactionRepository),
      }),
    ),
  )
  .register(
    serviceNames.creditCardFormViewController,
    diContainer.factory(
      c => new CreditCardFormViewController({
        creditCardFormStore: c.get(serviceNames.creditCardFormStore),
      }),
    ),
  )
  .register(
    serviceNames.cashFormViewController,
    diContainer.factory(
      c => new CashFormViewController({
        cashFormStore: c.get(serviceNames.cashFormStore),
      }),
    ),
  )
  .register(
    serviceNames.tncViewController,
    diContainer.factory(
      c => new TncViewController({
        configRepository: c.get(serviceNames.configRepository),
        tncRepository: c.get(serviceNames.tncRepository),
        transactionRepository: c.get(serviceNames.transactionRepository),
        translationRepository: c.get(serviceNames.translationRepository),
      }),
    ),
  )
  .register(
    serviceNames.klarnaMessagingViewController,
    diContainer.factory(
      c => new KlarnaMessagingViewController({
        configRepository: c.get(serviceNames.configRepository),
        klarnaRepository: c.get(serviceNames.klarnaRepository),
        transactionRepository: c.get(serviceNames.transactionRepository),
      }),
    ),
  )
  .register(
    serviceNames.companyBillingViewController,
    diContainer.factory(
      c => new CompanyBillingViewController({
        companyBillingDetailsRepository: c.get(serviceNames.companyBillingDetailsRepository),
        configRepository: c.get(serviceNames.configRepository),
        notificationsCollection: c.get(serviceNames.notificationsCollection),
        stateRouter: c.get(serviceNames.stateRouter),
        transactionRepository: c.get(serviceNames.transactionRepository),
      }),
    ),
  )
  .register(serviceNames.analyticsRepository, c => new AnalyticsRepository({
    api: c.get(serviceNames.apiSdk),
    transactionRepository: c.get(serviceNames.transactionRepository),
    uiState: c.get(serviceNames.uiState),
  }))
  .register(serviceNames.salonRepository, c => new SalonRepository({
    configRepository: c.get(serviceNames.configRepository),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
    salonApi: c.get(serviceNames.salonApi),
    salonFormStore: c.get(serviceNames.salonFormStore),
  }))
  .register(serviceNames.giftWrapRepository, c => new GiftWrapRepository({
    giftWrapApi: c.get(serviceNames.giftWrapApi),
    transactionRepository: c.get(serviceNames.transactionRepository),
  }))
  .register(serviceNames.transactionRepository, c => new TransactionRepository({
    api: c.get(serviceNames.apiSdk),
    billingRepository: c.get(serviceNames.billingRepository),
    configRepository: c.get(serviceNames.configRepository),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
    salonRepository: c.get(serviceNames.salonRepository),
    shippingRepository: c.get(serviceNames.shippingRepository),
  }))
  .register(serviceNames.configRepository, () => new ConfigRepository({
    api: diContainer.get(serviceNames.apiSdk),
    config: diContainer.get(serviceNames.config),
  }))
  .register(serviceNames.shippingRepository, c => new ShippingRepository({
    addressFormStore: c.get(serviceNames.addressFormStore),
    api: c.get(serviceNames.apiSdk),
    config: diContainer.get(serviceNames.config),
    melissaApi: c.get(serviceNames.melissaApi),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
    translationRepository: c.get(serviceNames.translationRepository),
  }))
  .register(serviceNames.packstationRepository, c => new PackstationRepository({
    addressFormStore: c.get(serviceNames.addressFormStore),
    api: c.get(serviceNames.apiSdk),
    config: diContainer.get(serviceNames.config),
    melissaApi: c.get(serviceNames.melissaApi),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
    translationRepository: c.get(serviceNames.translationRepository),
  }))
  .register(serviceNames.billingRepository, c => new BillingRepository({
    addressFormStore: c.get(serviceNames.addressFormStore),
    api: c.get(serviceNames.apiSdk),
    config: diContainer.get(serviceNames.config),
    melissaApi: c.get(serviceNames.melissaApi),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
    translationRepository: c.get(serviceNames.translationRepository),
  }))
  .register(serviceNames.bopisStoresRepository, c => new BopisStoresRepository({
    api: c.get(serviceNames.apiSdk),
    config: c.get(serviceNames.config),
    googleMapsApi: c.get(serviceNames.googleMapsApi),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
  }))
  .register(serviceNames.auPostCollectionsStoreRepository, () => new AUPostCollectionsRepository())
  .register(serviceNames.courierStoresRepository, c => new CourierStoresRepository({
    api: c.get(serviceNames.apiSdk),
    config: c.get(serviceNames.config),
    googleMapsApi: c.get(serviceNames.googleMapsApi),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
  }))
  .register(serviceNames.clickAndCollectRepository, c => new ClickAndCollectRepository({
    api: c.get(serviceNames.apiSdk),
    config: c.get(serviceNames.config),
    googleMapsApi: c.get(serviceNames.googleMapsApi),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
  }))
  .register(serviceNames.tncRepository, c => new TncRepository({
    api: c.get(serviceNames.apiSdk),
    configRepository: c.get(serviceNames.configRepository),
  }))
  .register(serviceNames.klarnaRepository, c => new KlarnaRepository({
    api: c.get(serviceNames.apiSdk),
    configRepository: c.get(serviceNames.configRepository),
  }))
  .register(serviceNames.companyBillingDetailsRepository, c => new CompanyBillingDetailsRepository({
    api: c.get(serviceNames.apiSdk),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
  }))
  .register(serviceNames.config, () => new Config())
  .register(serviceNames.user, () => new User())
  .register(serviceNames.userPreferences, () => new UserPreferences())
  .register(serviceNames.session, () => new Session())
  .register(serviceNames.userPreferencesRepository, c => new UserPreferencesRepository({
    api: c.get(serviceNames.apiSdk),
    userPreferences: c.get(serviceNames.userPreferences),
  }))
  .register(serviceNames.uiState, () => new UIState())
  .register(serviceNames.shippingUIState, () => new ShippingUIState())
  .register(serviceNames.giftCardUIState, () => new GiftCardViewState())
  .register(serviceNames.paymentService, () => new PaymentService())
  .register(serviceNames.loadStoresService, () => new LoadStoresService())
  .register(serviceNames.addressRepository, c => new AddressRepository({
    addressFormStore: c.get(serviceNames.addressFormStore),
    api: c.get(serviceNames.apiSdk),
    config: c.get(serviceNames.config),
    melissaApi: c.get(serviceNames.melissaApi),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
    translationRepository: c.get(serviceNames.translationRepository),
  }))
  .register(serviceNames.sessionRepository, () => new SessionRepository())
  .register(serviceNames.creditCardFormStore, () => new CreditCardFormStore())
  .register(serviceNames.cashFormStore, () => new CashFormStore())
  .register(serviceNames.notificationsRepository,
    c => new MessagesRepository({
      notificationsCollection: c.get(serviceNames.notificationsCollection),
      translationRepository: c.get(serviceNames.translationRepository),
    }))
  .register(serviceNames.notificationsService,
    c => new NotificationsService({
      notificationsCollection: c.get(serviceNames.notificationsCollection),
      notificationsRepository: c.get(serviceNames.notificationsRepository),
    }))
  .register(serviceNames.convenienceStoreViewController,
    c => new ConvenienceStoreViewController({
      configRepository: c.get(serviceNames.configRepository),
      transactionRepository: c.get(serviceNames.transactionRepository),
    }))
  .register(serviceNames.auPostCollectionsViewController,
    c => new AUPostCollectionsViewController({
      addressRepository: c.get(serviceNames.addressRepository),
      auPostCollectionsRepository: c.get(serviceNames.auPostCollectionsStoreRepository),
      configRepository: c.get(serviceNames.configRepository),
    }))
  .register(serviceNames.paymentRepository, c => new PaymentRepository({
    api: c.get(serviceNames.apiSdk),
    config: c.get(serviceNames.config),
    paymentService: c.get(serviceNames.paymentService),
    transactionRepository: c.get(serviceNames.transactionRepository),
  }))
  .register(serviceNames.paymentMethodViewRegistry, () => new PaymentMethodViewRegistry())
  .register(serviceNames.paymentMethodViewTitleRegistry, () => new PaymentMethodViewRegistry())
  .register(serviceNames.paymentMethodViewIconRegistry, () => new PaymentMethodViewRegistry())
  .register(serviceNames.paymentDisableMessageRegistry, () => new PaymentMethodViewRegistry())
  .register(serviceNames.paymentMethodViewController,
    diContainer.factory( c => new PaymentMethodViewController({
      config: c.get(serviceNames.config),
      paymentDisableMessageRegistry: c.get(serviceNames.paymentDisableMessageRegistry),
      paymentMethodIconRegistry: c.get(serviceNames.paymentMethodViewIconRegistry),
      paymentMethodTitleRegistry: c.get(serviceNames.paymentMethodViewTitleRegistry),
      paymentMethodViewRegistry: c.get(serviceNames.paymentMethodViewRegistry),
      paymentRepository: c.get(serviceNames.paymentRepository),
      paymentService: c.get(serviceNames.paymentService),
    })))
  .register(serviceNames.paymentAcceptTermsAndPrivacyViewConroller,
    c => new PaymentAcceptTermsAndPrivacyController({
      configRepository: c.get(serviceNames.configRepository),
      transactionRepository: c.get(serviceNames.transactionRepository),
      userPreferences: c.get(serviceNames.userPreferences),
    }))
  .register(serviceNames.translationRepository, () => new TranslationRepository())
  .register(serviceNames.addressFormStore,
    diContainer.factory(
      c => new AddressFormStore(c.get(serviceNames.config)),
    ))
  .register(serviceNames.charityDonationApi, c => new CharityDonationApi({
    api: c.get(serviceNames.apiSdk),
    dataMapper: c.get(serviceNames.apiDataMapper),
  }))
  .register(serviceNames.charityDonationRepository, c => new CharityDonationRepository({
    charityDonationApi: c.get(serviceNames.charityDonationApi),
    notificationsCollection: c.get(serviceNames.notificationsCollection),
    transactionRepository: c.get(serviceNames.transactionRepository),
  }))
  .register(serviceNames.charityDonationViewController, c => new CharityDonationViewController({
    charityDonationRepository: c.get(serviceNames.charityDonationRepository),
    paymentService: c.get(serviceNames.paymentService),
    transactionRepository: c.get(serviceNames.transactionRepository),
  }))
  .register(serviceNames.giftCardViewController,
    diContainer.factory(c => new GiftCardViewController({
      configRepository: c.get(serviceNames.configRepository),
      giftCardUIState: c.get(serviceNames.giftCardUIState),
      notificationsCollection: c.get(serviceNames.notificationsCollection),
      paymentRepository: c.get(serviceNames.paymentRepository),
      paymentService: c.get(serviceNames.paymentService),
      transactionRepository: c.get(serviceNames.transactionRepository),
      translationRepository: c.get(serviceNames.translationRepository),
    })))
  .register(serviceNames.salonFormStore, () => new SalonFormStore())
  .register(serviceNames.upsAddressValidationViewController, () =>
    new UpsAddressValidationViewController(),
  );
